const auth_status = {
    page_title: "Statut d'authentification",
    title: "Statut d'authentification",
    description: "Vérifiez le statut de l'authentification.",
};
export default Object.freeze(auth_status);
